import { Link } from 'react-router-dom'
import type { SiteEvent } from '../api/public'
import { CmsImage } from './CmsImage'

function parts(iso: string) {
  const d = new Date(iso)
  const months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
  return {
    day: String(d.getDate()).padStart(2, '0'),
    month: months[d.getMonth()].toUpperCase(),
  }
}

export function EventCard({ ev }: { ev: SiteEvent }) {
  const { day, month } = parts(ev.startsAt)
  const statusMod =
    ev.displayStatus === 'cancelled'
      ? 'event-card--cancelled'
      : ev.displayStatus === 'past'
        ? 'event-card--past'
        : ''
  const mod = [statusMod, !ev.featuredImageUrl ? 'event-card--no-poster' : ''].filter(Boolean).join(' ')
  const loc = [ev.venueName, ev.locationLabel].filter(Boolean).join(' · ')
  const timeLabel = new Date(ev.startsAt).toLocaleTimeString('de-CH', {
    hour: '2-digit',
    minute: '2-digit',
  })
  const where = [timeLabel, loc].filter(Boolean).join(' · ')

  const label = `${ev.title} — ${where}`

  return (
    <Link
      to={`/events/${ev.slug}`}
      className={['event-card', mod].filter(Boolean).join(' ')}
      aria-label={label}
      role="listitem"
    >
      <div className="date" aria-hidden>
        <span className="d">{day}</span>
        <div className="m">{month}</div>
      </div>
      <div>
        <div className="ttl">{ev.title}</div>
        <div className="where">{where}</div>
        {ev.displayStatus === 'cancelled' ? (
          <div className="where" style={{ color: 'var(--hot)', marginTop: 6 }}>
            Abgesagt
          </div>
        ) : null}
      </div>
      {ev.featuredImageUrl ? (
        <div className="poster" aria-hidden>
          <CmsImage src={ev.featuredImageUrl} size="thumb" alt="" />
        </div>
      ) : null}
      <span className="go" aria-hidden>→</span>
    </Link>
  )
}
